import styled from 'styled-components';
import Modal from '../../../components/Modal';
import {
  ParagraphLargeText,
  ParagraphSmallText,
} from '../../../components/Texts';
import Button from '../../../components/Button';
import { useSelector } from 'react-redux';
import { selectPrivyToken } from '../../../redux/slices/auth';
import { useState } from 'react';
import {
  useGetDebitCardWaitlistQuery,
  useJoinDebitCardWaitlistMutation,
} from '../../../redux/api/authorized/debitCard';

const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
  text-align: center;
  gap: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledModal = styled(Modal)`
  .modal-content {
    overflow: hidden;
    max-height: 700px;
  }
`;

const DebitCard = styled.img`
  width: 100%;
  max-width: 400px;
  object-fit: cover;
`;

const DebitCardWaitlist = ({ onClose }) => {
  const privyToken = useSelector(selectPrivyToken);
  const [loading, setLoading] = useState(false);
  const { data, refetch } = useGetDebitCardWaitlistQuery(undefined, {
    skip: !privyToken,
  });

  const [joinDebitCardWaitlist] = useJoinDebitCardWaitlistMutation();

  return (
    <StyledModal onClose={onClose}>
      <ContentContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <ParagraphLargeText>{'GET YOUR CARD'}</ParagraphLargeText>
        </div>
        <DebitCard src={'/debit-card/card.webp'} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <ParagraphSmallText style={{ fontWeight: 700 }}>
            Spend your crypto anywhere
          </ParagraphSmallText>
          <ParagraphSmallText style={{ fontWeight: 500, marginBottom: 16 }}>
            Your funds stay in your control, no hidden fees, no middlemen. Join
            the waitlist today and be among the first to experience it.
          </ParagraphSmallText>
          <Button
            loading={loading}
            disabled={data?.isInWaitlist}
            fullWidth
            onClick={async () => {
              setLoading(true);
              await joinDebitCardWaitlist();
              await refetch();
              setLoading(false);
            }}
          >
            {data?.isInWaitlist ? 'ALREADY JOINED' : 'JOIN THE WAITLIST'}
          </Button>
        </div>
      </ContentContainer>
    </StyledModal>
  );
};

export default DebitCardWaitlist;
